export default "__VITE_ASSET__D66_e11S__"